import PropTypes from 'prop-types';
import React from 'react';

// Styles
import './style.scss';

const Toggle = ({ label, isOn, handleToggle }) => {
  return (
    <div className="toggle">
      <div className={`toggle_title ${isOn ? '' : 'toggle_title_on'}`}>{label[0]}</div>
      <input checked={isOn} onChange={handleToggle} className="react-switch-checkbox" id="react-switch-new" type="checkbox" />
      <label style={{ background: isOn && '#323232' }} className="react-switch-label" htmlFor="react-switch-new">
        <span className="react-switch-button" />
      </label>

      <div className={`toggle_title ${isOn ? 'toggle_title_on' : ''}`}>{label[1]}</div>
    </div>
  );
};

Toggle.propTypes = {
  label: PropTypes.arrayOf(PropTypes.string).isRequired,
  isOn: PropTypes.bool.isRequired,
  handleToggle: PropTypes.func.isRequired
};

export default Toggle;
